import React, { useContext } from 'react';

import { Select } from 'antd';
import _ from 'lodash';

//import { ListContext } from '@contexts/ListContext';
import { UserContext } from '@contexts/UserContext';

import useNetworkAgencies from '@hooks/CachedLists/UseNetworkAgencies';

const NetworkAgencySelector = ({ value, onChange, mode, accountingGroupID, available, emptyValue, ...rest }) => {
    const { currentUser } = useContext(UserContext);
    const networkAgenciesObject = useNetworkAgencies(accountingGroupID, available);

    const renderOptions = () => {
        const networkAgenciesGrouped = _.groupBy(networkAgenciesObject, 'accountingGroupName');
        const networkAgenciesOptions = Object.entries(networkAgenciesGrouped).map(([accGroup, agencies]) => ({
            accGroup,
            agencies: agencies.map(({ ID, Name }) => ({
                Name: Name,
                ID: ID,
            })),
        }));
        return (
            <>
                {emptyValue && (
                    <Select.Option value={null} label="All Network Agencies">
                        All Network Agencies
                    </Select.Option>
                )}
                {networkAgenciesOptions.map(({ accGroup, agencies }) => (
                    <Select.OptGroup key={accGroup} label={accGroup}>
                        {agencies.map(({ Name, ID }) => (
                            <Select.Option key={ID} value={ID} label={`${accGroup} / ${Name}`}>
                                {Name}
                            </Select.Option>
                        ))}
                    </Select.OptGroup>
                ))}
            </>
        );
    };

    return (
        <Select
            autoComplete="off"
            mode={mode}
            value={value ? value : emptyValue ? null : currentUser.ActiveContext.nwAgId}
            label={rest.label ? rest.label : 'Network Agency'}
            style={{ width: '100%', minWidth: '200px' }}
            placeholder="Select Network Agency"
            onChange={onChange}
            allowClear={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            optionLabelProp="label"
        >
            {renderOptions()}
        </Select>
    );
};

export default NetworkAgencySelector;
